// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AccountRegisterData, AccountRegisterResponse, AccountLoginData, AccountLoginResponse, AccountLoginTokenData, AccountLoginTokenResponse, AccountRefreshData, AccountRefreshResponse, AccountResendConfirmationEmailData, AccountResendConfirmationEmailResponse, AccountForgotPasswordData, AccountForgotPasswordResponse, AccountResetPasswordData, AccountResetPasswordResponse, AccountGetUsersResponse, AccountUpdateUserData, AccountUpdateUserResponse, AccountDeleteUserData, AccountDeleteUserResponse, AccountSetApiKeyData, AccountSetApiKeyResponse, AccountLogoutResponse, AccountGetInfoResponse, AccountUpdateInfoData, AccountUpdateInfoResponse, BlobStorageReprocessBlobsByFolderData, BlobStorageReprocessBlobsByFolderResponse, BlobStorageReprocessBlobsByTagsData, BlobStorageReprocessBlobsByTagsResponse, ChamberFluxCalculateChamberFluxData, ChamberFluxCalculateChamberFluxResponse, ChamberFluxFullChamberFluxCalculationData, ChamberFluxFullChamberFluxCalculationResponse, ChamberMappingGetChamberMappingsData, ChamberMappingGetChamberMappingsResponse, ChamberMappingCreateChamberMappingData, ChamberMappingCreateChamberMappingResponse, ChamberMappingUpdateChamberMappingData, ChamberMappingUpdateChamberMappingResponse, ChamberMappingDeleteChamberMappingData, ChamberMappingDeleteChamberMappingResponse, DataExportRequestSiteExportData, DataExportRequestSiteExportResponse, DataExportGetSiteExportLegacyData, DataExportGetSiteExportLegacyResponse, DataExportGetExportJobStatusData, DataExportGetExportJobStatusResponse, DataExportQueueSiteExportData, DataExportQueueSiteExportResponse, DataExportGetSiteExportData, DataExportGetSiteExportResponse, DataExportGetSiteHierarchyData, DataExportGetSiteHierarchyResponse, DataExportRequestLocationExportData, DataExportRequestLocationExportResponse, DataExportGetAnnualExportData, DataExportGetAnnualExportResponse, DataExportQueueChamberFluxWideExportData, DataExportQueueChamberFluxWideExportResponse, DataExportGetObservationsPageData, DataExportGetObservationsPageResponse, DataExportGetManualExportReadmeResponse, DataExportGetFarmerDataResponse, DataWarehouseIngestPlotMeasurementsData, DataWarehouseIngestPlotMeasurementsResponse, DataWarehouseDigestPlotMeasurementsResponse, DataWarehouseIngestFieldTreatmentsData, DataWarehouseIngestFieldTreatmentsResponse, DataWarehouseDigestFieldTreatmentsResponse, DataWarehouseIngestTrialTreatmentsData, DataWarehouseIngestTrialTreatmentsResponse, DataWarehouseDigestTrialTreatmentsResponse, DataWarehouseIngestTrialMeasurementsData, DataWarehouseIngestTrialMeasurementsResponse, DataWarehouseDigestTrialMeasurementsResponse, DataWarehouseIngestTreatmentMeasurementsData, DataWarehouseIngestTreatmentMeasurementsResponse, DataWarehouseDigestTreatmentMeasurementsResponse, DataWarehouseIngestPlotCalculatedResultsData, DataWarehouseIngestPlotCalculatedResultsResponse, DataWarehouseDigestPlotCalculatedResultsResponse, DataWarehouseIngestTreatmentCalculatedResultsData, DataWarehouseIngestTreatmentCalculatedResultsResponse, DataWarehouseDigestTreatmentCalculatedResultsResponse, DataWarehouseIngestCropsData, DataWarehouseIngestCropsResponse, DataWarehouseDigestCropsResponse, DataWarehouseIngestFluxResultsData, DataWarehouseIngestFluxResultsResponse, DataWarehouseDigestFluxResultsResponse, DataWarehouseIngestSoilSampleResultsData, DataWarehouseIngestSoilSampleResultsResponse, DataWarehouseDigestSoilSampleResultsResponse, DataWarehouseIngestBulkDensityResultsData, DataWarehouseIngestBulkDensityResultsResponse, DataWarehouseDigestBulkDensityResultsResponse, DataWarehouseMapSensorsToLocationsData, DataWarehouseMapSensorsToLocationsResponse, DmiConfigurationSetFallbackStationData, DmiConfigurationSetFallbackStationResponse, DmiWeatherBackfillData, DmiWeatherBackfillResponse, ExperimentalLocationGetExperimentalLocationsData, ExperimentalLocationGetExperimentalLocationsResponse, ExperimentalLocationCreateExperimentalLocationData, ExperimentalLocationCreateExperimentalLocationResponse, ExperimentalLocationGetExperimentalLocationData, ExperimentalLocationGetExperimentalLocationResponse, ExperimentalLocationUpdateExperimentalLocationData, ExperimentalLocationUpdateExperimentalLocationResponse, ExperimentalLocationDeleteExperimentalLocationData, ExperimentalLocationDeleteExperimentalLocationResponse, ExperimentalLocationGetTreatmentsData, ExperimentalLocationGetTreatmentsResponse, ExperimentalLocationUpdateTreatmentData, ExperimentalLocationUpdateTreatmentResponse, FieldNotesGetFieldNotesData, FieldNotesGetFieldNotesResponse, FieldNotesCreateFieldNoteData, FieldNotesCreateFieldNoteResponse, FieldNotesDeleteFieldNoteData, FieldNotesDeleteFieldNoteResponse, FilesListFilesData, FilesListFilesResponse, FilesDownloadFileData, FilesDownloadFileResponse, FluxGradientCalculateFluxGradientData, FluxGradientCalculateFluxGradientResponse, GeographyUpdateExperimentalLocationPolygonsResponse, HealthCheckIsHealthyResponse, HealthCheckIsAliveResponse, PlotGetPlotsData, PlotGetPlotsResponse, PlotCreatePlotData, PlotCreatePlotResponse, PlotGetPlotData, PlotGetPlotResponse, PlotUpdatePlotData, PlotUpdatePlotResponse, PlotDeletePlotData, PlotDeletePlotResponse, SensorGetSensorsData, SensorGetSensorsResponse, SensorGetSensorData, SensorGetSensorResponse, SensorGetPlacementHistoryData, SensorGetPlacementHistoryResponse, SensorPostPlacementData, SensorPostPlacementResponse, SensorPatchPropertiesData, SensorPatchPropertiesResponse, SensorBulkApplyPropertiesData, SensorBulkApplyPropertiesResponse, SensorAggregationScheduleAggregationData, SensorAggregationScheduleAggregationResponse, SiteGetSitesResponse, SiteCreateSiteData, SiteCreateSiteResponse, SiteGetSiteData, SiteGetSiteResponse, SiteUpdateSiteData, SiteUpdateSiteResponse, SiteGetSiteHistoryData, SiteGetSiteHistoryResponse, SiteSetStartedData, SiteSetStartedResponse, SiteSetStoppedData, SiteSetStoppedResponse, SiteSetLocationData, SiteSetLocationResponse, SiteSetShapeData, SiteSetShapeResponse, SiteSetNameData, SiteSetNameResponse, SiteGeometryExportGeoJsonData, SiteGeometryExportGeoJsonResponse, SiteGeometryExportGeoJsonBundleData, SiteGeometryExportGeoJsonBundleResponse, SiteGeometryImportGeoJsonData, SiteGeometryImportGeoJsonResponse, SiteHistoryGetSiteHistoryEntriesResponse, SiteHistoryGetSiteHistoryEntryData, SiteHistoryGetSiteHistoryEntryResponse, SiteOperationLogGetSiteOperationLogEntriesForSiteData, SiteOperationLogGetSiteOperationLogEntriesForSiteResponse, SiteOperationLogGetSiteOperationLogEntryData, SiteOperationLogGetSiteOperationLogEntryResponse, SiteOperationLogCreateSiteOperationLogEntryData, SiteOperationLogCreateSiteOperationLogEntryResponse, TowerMappingGetTowerMappingsData, TowerMappingGetTowerMappingsResponse, TowerMappingCreateTowerMappingData, TowerMappingCreateTowerMappingResponse, TowerMappingUpdateTowerMappingData, TowerMappingUpdateTowerMappingResponse, TowerMappingDeleteTowerMappingData, TowerMappingDeleteTowerMappingResponse, TreatmentsGetSiteTreatmentsData, TreatmentsGetSiteTreatmentsResponse, TreatmentsUpdateTreatmentData, TreatmentsUpdateTreatmentResponse, WebhookMeterGroupWebhookEndpointData, WebhookMeterGroupWebhookEndpointResponse } from './types.gen';

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const accountRegister = (data: AccountRegisterData): CancelablePromise<AccountRegisterResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/account/register',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SmartField_Authorization_Contracts_ClaimDto OK
 * @throws ApiError
 */
export const accountLogin = (data: AccountLoginData): CancelablePromise<AccountLoginResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/account/login',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const accountLoginToken = (data: AccountLoginTokenData): CancelablePromise<AccountLoginTokenResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/account/login-token',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Microsoft_AspNetCore_Authentication_BearerToken_AccessTokenResponse OK
 * @throws ApiError
 */
export const accountRefresh = (data: AccountRefreshData): CancelablePromise<AccountRefreshResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/account/refresh',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const accountResendConfirmationEmail = (data: AccountResendConfirmationEmailData): CancelablePromise<AccountResendConfirmationEmailResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/account/resendConfirmationEmail',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const accountForgotPassword = (data: AccountForgotPasswordData): CancelablePromise<AccountForgotPasswordResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/account/forgotPassword',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const accountResetPassword = (data: AccountResetPasswordData): CancelablePromise<AccountResetPasswordResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/account/resetPassword',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request'
    }
}); };

/**
 * @returns SmartField_Api_Contracts_Account_UserListItemDto OK
 * @throws ApiError
 */
export const accountGetUsers = (): CancelablePromise<AccountGetUsersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/account/users'
}); };

/**
 * @param data The data for the request.
 * @param data.userId
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const accountUpdateUser = (data: AccountUpdateUserData): CancelablePromise<AccountUpdateUserResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/v1/account/users/{userId}',
    path: {
        userId: data.userId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        404: 'Not Found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.userId
 * @returns unknown OK
 * @throws ApiError
 */
export const accountDeleteUser = (data: AccountDeleteUserData): CancelablePromise<AccountDeleteUserResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v1/account/users/{userId}',
    path: {
        userId: data.userId
    },
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.userId
 * @param data.apiKey
 * @returns SmartField_Api_Contracts_Account_SetApiKeyResponseDto OK
 * @throws ApiError
 */
export const accountSetApiKey = (data: AccountSetApiKeyData): CancelablePromise<AccountSetApiKeyResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v1/account/apikey',
    query: {
        userId: data.userId,
        apiKey: data.apiKey
    },
    errors: {
        400: 'Bad Request',
        404: 'Not Found'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const accountLogout = (): CancelablePromise<AccountLogoutResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/account/logout'
}); };

/**
 * @returns SmartField_Api_Contracts_Account_UserInfoResponse OK
 * @throws ApiError
 */
export const accountGetInfo = (): CancelablePromise<AccountGetInfoResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/account/manage/info',
    errors: {
        400: 'Bad Request',
        404: 'Not Found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Microsoft_AspNetCore_Identity_Data_InfoResponse OK
 * @throws ApiError
 */
export const accountUpdateInfo = (data: AccountUpdateInfoData): CancelablePromise<AccountUpdateInfoResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/account/manage/info',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        404: 'Not Found'
    }
}); };

/**
 * Marks all blobs in the container containerName in the folder folderPath.
 *
 * Given the containerName`DK-Fou` and folderPath`raw`, all files within the `DK-Fou/raw` folder will be marked for reprocessing.
 * Re-processing of files happens in the background, and can take several hours, depending on how many files changed.
 * This endpoint has a timeout of 15 minutes.
 * @param data The data for the request.
 * @param data.containerName
 * @param data.folderPath
 * @returns SmartField_Api_Controllers_ReprocessResult OK
 * @throws ApiError
 */
export const blobStorageReprocessBlobsByFolder = (data: BlobStorageReprocessBlobsByFolderData = {}): CancelablePromise<BlobStorageReprocessBlobsByFolderResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/blob-storage/reprocess/by-folder',
    query: {
        containerName: data.containerName,
        folderPath: data.folderPath
    },
    errors: {
        401: 'Unauthorized',
        404: 'Not Found'
    }
}); };

/**
 * Finds all blobs matching tags and marks them for re-processing.
 *
 * Re-processing of files happens in the background, and can take several hours, depending on how many files changed.
 * This endpoint has a timeout of 15 minutes.
 * @param data The data for the request.
 * @param data.tags The tags to search for blobs by.
 * @param data.containerName Supply a containerName to limit this operation to a certain container.
 * @returns SmartField_Api_Controllers_ReprocessResult OK
 * @throws ApiError
 */
export const blobStorageReprocessBlobsByTags = (data: BlobStorageReprocessBlobsByTagsData = {}): CancelablePromise<BlobStorageReprocessBlobsByTagsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/blob-storage/reprocess/by-tags',
    query: {
        tags: data.tags,
        containerName: data.containerName
    },
    errors: {
        401: 'Unauthorized',
        404: 'Not Found'
    }
}); };

/**
 * Calculates chamber flux for the given site, gas type and time frame, and stores the result in InfluxDB.
 * @param data The data for the request.
 * @param data.siteCode
 * @param data.gasType
 * @param data.startTime
 * @param data.stopTime
 * @param data.useOutliers
 * @returns unknown OK
 * @throws ApiError
 */
export const chamberFluxCalculateChamberFlux = (data: ChamberFluxCalculateChamberFluxData = {}): CancelablePromise<ChamberFluxCalculateChamberFluxResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/chamberflux/calculate',
    query: {
        siteCode: data.siteCode,
        gasType: data.gasType,
        startTime: data.startTime,
        stopTime: data.stopTime,
        useOutliers: data.useOutliers
    }
}); };

/**
 * Schedules chamber flux calculations for configured sites (dk-had, dk-fou) in the time frame.
 * Publishes one message per (site, outlierVariant, day) to the message bus for reliable distributed processing.
 * Gas-type fan-out occurs inside SmartField.Api.Features.ChamberFlux.Consumers.ChamberFluxCalculationConsumer.
 * @param data The data for the request.
 * @param data.startTime
 * @param data.stopTime
 * @returns unknown OK
 * @throws ApiError
 */
export const chamberFluxFullChamberFluxCalculation = (data: ChamberFluxFullChamberFluxCalculationData = {}): CancelablePromise<ChamberFluxFullChamberFluxCalculationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/chamberflux/calculate_all',
    query: {
        startTime: data.startTime,
        stopTime: data.stopTime
    }
}); };

/**
 * @param data The data for the request.
 * @param data.siteId
 * @param data.year
 * @returns SmartField_Api_Contracts_Mapping_ChamberMappingDto OK
 * @throws ApiError
 */
export const chamberMappingGetChamberMappings = (data: ChamberMappingGetChamberMappingsData): CancelablePromise<ChamberMappingGetChamberMappingsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/chamber-mappings',
    path: {
        siteId: data.siteId
    },
    query: {
        year: data.year
    }
}); };

/**
 * @param data The data for the request.
 * @param data.siteId
 * @param data.requestBody
 * @returns SmartField_Api_Contracts_Mapping_ChamberMappingDto Created
 * @throws ApiError
 */
export const chamberMappingCreateChamberMapping = (data: ChamberMappingCreateChamberMappingData): CancelablePromise<ChamberMappingCreateChamberMappingResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sites/{siteId}/chamber-mappings',
    path: {
        siteId: data.siteId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const chamberMappingUpdateChamberMapping = (data: ChamberMappingUpdateChamberMappingData): CancelablePromise<ChamberMappingUpdateChamberMappingResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/v1/sites/{siteId}/chamber-mappings/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @returns void No Content
 * @throws ApiError
 */
export const chamberMappingDeleteChamberMapping = (data: ChamberMappingDeleteChamberMappingData): CancelablePromise<ChamberMappingDeleteChamberMappingResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v1/sites/{siteId}/chamber-mappings/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * @deprecated
 * Queue a site data export. Returns immediately — an email with a download link is sent to you when ready.
 * The link is valid for 7 days.
 * Period formats:
 * - Week: "2025-W03" (ISO 8601 week, Monday–Sunday)
 * - Month: "2025-06"
 * - Year: "2025"
 * @param data The data for the request.
 * @param data.siteName
 * @param data.rangeType
 * @param data.period
 * @param data.includeSensorData
 * @returns SmartField_Api_Features_DataWarehouse_DataExport_ExportJobAcceptedDto Accepted
 * @throws ApiError
 */
export const dataExportRequestSiteExport = (data: DataExportRequestSiteExportData = {}): CancelablePromise<DataExportRequestSiteExportResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/data-export/site',
    query: {
        SiteName: data.siteName,
        RangeType: data.rangeType,
        Period: data.period,
        IncludeSensorData: data.includeSensorData
    },
    errors: {
        400: 'Bad Request'
    }
}); };

/**
 * @deprecated
 * Synchronous site export. Returns processed flux and sensor data as JSON for the requested date range.
 * Arbitrary range supported — large ranges (e.g. 1 year) may take up to 30 minutes. Client must not time out.
 * @param data The data for the request.
 * @param data.siteName
 * @param data.start
 * @param data.end
 * @param data.includeSensorData
 * @returns SmartField_Api_Features_DataWarehouse_DataExport_SiteExportDto OK
 * @throws ApiError
 */
export const dataExportGetSiteExportLegacy = (data: DataExportGetSiteExportLegacyData = {}): CancelablePromise<DataExportGetSiteExportLegacyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/data-export/site/json',
    query: {
        SiteName: data.siteName,
        Start: data.start,
        End: data.end,
        IncludeSensorData: data.includeSensorData
    },
    errors: {
        400: 'Bad Request'
    }
}); };

/**
 * Get status of a queued export job. When State is Completed, DownloadUrl contains a 7-day SAS link.
 * @param data The data for the request.
 * @param data.jobId
 * @returns SmartField_Api_Features_DataWarehouse_DataExport_ExportJobStatus OK
 * @throws ApiError
 */
export const dataExportGetExportJobStatus = (data: DataExportGetExportJobStatusData): CancelablePromise<DataExportGetExportJobStatusResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/data-export/jobs/{jobId}',
    path: {
        jobId: data.jobId
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Queue a site data export for an arbitrary date range.
 * Returns immediately — an email with a download link is sent when ready. The link is valid for 7 days.
 * @param data The data for the request.
 * @param data.siteCode
 * @param data.startTime
 * @param data.endTime
 * @param data.includeSensorData
 * @returns SmartField_Api_Features_DataWarehouse_DataExport_ExportJobAcceptedDto Accepted
 * @throws ApiError
 */
export const dataExportQueueSiteExport = (data: DataExportQueueSiteExportData): CancelablePromise<DataExportQueueSiteExportResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/data-export/site/{siteCode}/queue-export',
    path: {
        siteCode: data.siteCode
    },
    query: {
        startTime: data.startTime,
        endTime: data.endTime,
        includeSensorData: data.includeSensorData
    },
    errors: {
        400: 'Bad Request',
        404: 'Not Found'
    }
}); };

/**
 * Synchronous site export — returns full JSON for programmatic access.
 * Reads from in-memory cache. Returns 503 with Retry-After: 60 if cache not yet warmed.
 * @param data The data for the request.
 * @param data.siteCode
 * @param data.dateRange
 * @param data.includeSensorData
 * @returns SmartField_Api_Features_DataWarehouse_DataExport_SiteExportDto OK
 * @throws ApiError
 */
export const dataExportGetSiteExport = (data: DataExportGetSiteExportData): CancelablePromise<DataExportGetSiteExportResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/data-export/site/{siteCode}/export',
    path: {
        siteCode: data.siteCode
    },
    query: {
        dateRange: data.dateRange,
        includeSensorData: data.includeSensorData
    },
    errors: {
        400: 'Bad Request',
        404: 'Not Found',
        503: 'Service Unavailable'
    }
}); };

/**
 * Get a lightweight site hierarchy (fields, treatments, plots) with observation counts for the date range.
 * Used to drive the export preview UI without loading observation rows.
 * @param data The data for the request.
 * @param data.siteSerialNumber
 * @param data.startTime
 * @param data.endTime
 * @returns SmartField_Api_Features_DataWarehouse_DataExport_SiteHierarchyDto OK
 * @throws ApiError
 */
export const dataExportGetSiteHierarchy = (data: DataExportGetSiteHierarchyData): CancelablePromise<DataExportGetSiteHierarchyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/data-export/site/{siteSerialNumber}/hierarchy',
    path: {
        siteSerialNumber: data.siteSerialNumber
    },
    query: {
        startTime: data.startTime,
        endTime: data.endTime
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Queue a scoped export for specific locations/sensors. A ZIP of CSVs is emailed when ready.
 * @param data The data for the request.
 * @param data.siteSerialNumber
 * @param data.requestBody
 * @returns SmartField_Api_Features_DataWarehouse_DataExport_ExportJobAcceptedDto Accepted
 * @throws ApiError
 */
export const dataExportRequestLocationExport = (data: DataExportRequestLocationExportData): CancelablePromise<DataExportRequestLocationExportResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/data-export/site/{siteSerialNumber}/export',
    path: {
        siteSerialNumber: data.siteSerialNumber
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request'
    }
}); };

/**
 * Returns a SAS download URL for the annual full-site export (JSON + GZ).
 * If the cache blob is fresh (< 25 h old), returns 200 with the URL immediately.
 * If missing or stale, enqueues a cache-warming job and returns 202 — poll again in ~5 minutes.
 * @param data The data for the request.
 * @param data.siteCode
 * @param data.year
 * @returns unknown OK
 * @returns unknown Accepted
 * @throws ApiError
 */
export const dataExportGetAnnualExport = (data: DataExportGetAnnualExportData): CancelablePromise<DataExportGetAnnualExportResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/data-export/site/{siteCode}/annual/{year}',
    path: {
        siteCode: data.siteCode,
        year: data.year
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Queue a wide-format chamber flux CSV export for a site and date range.
 * Each row in the output is one chamber closure event with CO₂, CH₄, and N₂O columns side-by-side.
 * Returns immediately — an email with a download link is sent when ready. The link is valid for 7 days.
 * @param data The data for the request.
 * @param data.siteCode
 * @param data.startTime
 * @param data.endTime
 * @param data.channels
 * @returns SmartField_Api_Features_DataWarehouse_DataExport_ExportJobAcceptedDto Accepted
 * @throws ApiError
 */
export const dataExportQueueChamberFluxWideExport = (data: DataExportQueueChamberFluxWideExportData): CancelablePromise<DataExportQueueChamberFluxWideExportResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/data-export/site/{siteCode}/queue-chamber-flux-export',
    path: {
        siteCode: data.siteCode
    },
    query: {
        startTime: data.startTime,
        endTime: data.endTime,
        channels: data.channels
    },
    errors: {
        400: 'Bad Request',
        404: 'Not Found'
    }
}); };

/**
 * Paged manual or flux observations for a site, filtered by optional field/treatment/plot.
 * @param data The data for the request.
 * @param data.siteSerialNumber
 * @param data.startTime
 * @param data.endTime
 * @param data.fieldId
 * @param data.treatmentDescription
 * @param data.plotId
 * @param data.locationId
 * @param data.kind
 * @param data.page
 * @param data.pageSize
 * @returns SmartField_Api_Features_DataWarehouse_DataExport_PagedObservationsDto OK
 * @throws ApiError
 */
export const dataExportGetObservationsPage = (data: DataExportGetObservationsPageData): CancelablePromise<DataExportGetObservationsPageResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/data-export/site/{siteSerialNumber}/observations',
    path: {
        siteSerialNumber: data.siteSerialNumber
    },
    query: {
        startTime: data.startTime,
        endTime: data.endTime,
        fieldId: data.fieldId,
        treatmentDescription: data.treatmentDescription,
        plotId: data.plotId,
        locationId: data.locationId,
        kind: data.kind,
        page: data.page,
        pageSize: data.pageSize
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * The manual data export readme as markdown: the CSV column reference and measure-group
 * data dictionary shipped as {site}_readme.html with every manual export.
 * @returns string OK
 * @throws ApiError
 */
export const dataExportGetManualExportReadme = (): CancelablePromise<DataExportGetManualExportReadmeResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/data-export/manual-export-readme'
}); };

/**
 * Lists downloadable farmer data ZIP archives (one per year). Not site-scoped — available to any authenticated user.
 * @returns SmartField_Api_Controllers_FarmerDataFileDto OK
 * @throws ApiError
 */
export const dataExportGetFarmerData = (): CancelablePromise<DataExportGetFarmerDataResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/data-export/farmer-data'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestPlotMeasurements = (data: DataWarehouseIngestPlotMeasurementsData = {}): CancelablePromise<DataWarehouseIngestPlotMeasurementsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/plot-measurements/ingest',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestPlotMeasurements = (): CancelablePromise<DataWarehouseDigestPlotMeasurementsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/plot-measurements/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestFieldTreatments = (data: DataWarehouseIngestFieldTreatmentsData = {}): CancelablePromise<DataWarehouseIngestFieldTreatmentsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/field-treatments/ingest',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestFieldTreatments = (): CancelablePromise<DataWarehouseDigestFieldTreatmentsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/field-treatments/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestTrialTreatments = (data: DataWarehouseIngestTrialTreatmentsData = {}): CancelablePromise<DataWarehouseIngestTrialTreatmentsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/trial-treatments/ingest',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestTrialTreatments = (): CancelablePromise<DataWarehouseDigestTrialTreatmentsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/trial-treatments/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestTrialMeasurements = (data: DataWarehouseIngestTrialMeasurementsData = {}): CancelablePromise<DataWarehouseIngestTrialMeasurementsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/trial-measurements/ingest',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestTrialMeasurements = (): CancelablePromise<DataWarehouseDigestTrialMeasurementsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/trial-measurements/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestTreatmentMeasurements = (data: DataWarehouseIngestTreatmentMeasurementsData = {}): CancelablePromise<DataWarehouseIngestTreatmentMeasurementsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/treatment-measurements/ingest',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestTreatmentMeasurements = (): CancelablePromise<DataWarehouseDigestTreatmentMeasurementsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/treatment-measurements/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestPlotCalculatedResults = (data: DataWarehouseIngestPlotCalculatedResultsData = {}): CancelablePromise<DataWarehouseIngestPlotCalculatedResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/plot-calculated-results/ingest',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestPlotCalculatedResults = (): CancelablePromise<DataWarehouseDigestPlotCalculatedResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/plot-calculated-results/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestTreatmentCalculatedResults = (data: DataWarehouseIngestTreatmentCalculatedResultsData = {}): CancelablePromise<DataWarehouseIngestTreatmentCalculatedResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/treatment-calculated-results/ingest',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestTreatmentCalculatedResults = (): CancelablePromise<DataWarehouseDigestTreatmentCalculatedResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/treatment-calculated-results/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestCrops = (data: DataWarehouseIngestCropsData = {}): CancelablePromise<DataWarehouseIngestCropsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/crops/ingest',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestCrops = (): CancelablePromise<DataWarehouseDigestCropsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/nfts/crops/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestFluxResults = (data: DataWarehouseIngestFluxResultsData = {}): CancelablePromise<DataWarehouseIngestFluxResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/flux-results/ingest',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestFluxResults = (): CancelablePromise<DataWarehouseDigestFluxResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/flux-results/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.site
 * @param data.formData
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestSoilSampleResults = (data: DataWarehouseIngestSoilSampleResultsData = {}): CancelablePromise<DataWarehouseIngestSoilSampleResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/soil-sample-results/ingest',
    query: {
        site: data.site
    },
    formData: data.formData,
    mediaType: 'multipart/form-data',
    errors: {
        400: 'Bad Request',
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestSoilSampleResults = (): CancelablePromise<DataWarehouseDigestSoilSampleResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/soil-sample-results/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.site
 * @param data.formData
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseIngestBulkDensityResults = (data: DataWarehouseIngestBulkDensityResultsData = {}): CancelablePromise<DataWarehouseIngestBulkDensityResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/bulk-density-results/ingest',
    query: {
        site: data.site
    },
    formData: data.formData,
    mediaType: 'multipart/form-data',
    errors: {
        400: 'Bad Request',
        500: 'Internal Server Error'
    }
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseDigestBulkDensityResults = (): CancelablePromise<DataWarehouseDigestBulkDensityResultsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/bulk-density-results/digest',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const dataWarehouseMapSensorsToLocations = (data: DataWarehouseMapSensorsToLocationsData = {}): CancelablePromise<DataWarehouseMapSensorsToLocationsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/datawarehouse/sensor-location-mapping',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * Finds the nearest DMI station to the given (or site's current) location and registers it as the
 * fallback DMI station used when on-site sensors have no data. Written to InfluxDB as the
 * "fallback_dmi_station_id" field on the "site_configuration" measurement, timestamped at
 * request.EffectiveAt (defaults to now). Mobile sites can call this retroactively
 * with a past EffectiveAt and the lat/long the site was at then, to backfill station history.
 * @param data The data for the request.
 * @param data.siteSerialNumber
 * @param data.requestBody
 * @returns SmartField_Api_Features_Dmi_StationInfo OK
 * @throws ApiError
 */
export const dmiConfigurationSetFallbackStation = (data: DmiConfigurationSetFallbackStationData): CancelablePromise<DmiConfigurationSetFallbackStationResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/v1/sites/{siteSerialNumber}/dmi-configuration/fallback-station',
    path: {
        siteSerialNumber: data.siteSerialNumber
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Backfills DMI weather data for a site over the given time range.
 * @param data The data for the request.
 * @param data.siteSerialNumber
 * @param data.startTime Defaults to 1 year ago. Format: yyyy-MM-ddTHH:mm:ssZ
 * @param data.stopTime Defaults to now. Format: yyyy-MM-ddTHH:mm:ssZ
 * @returns unknown OK
 * @throws ApiError
 */
export const dmiWeatherBackfill = (data: DmiWeatherBackfillData = {}): CancelablePromise<DmiWeatherBackfillResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/dmi-weather/backfill',
    query: {
        siteSerialNumber: data.siteSerialNumber,
        startTime: data.startTime,
        stopTime: data.stopTime
    },
    errors: {
        400: 'Bad Request'
    }
}); };

/**
 * Get all experimental locations for a site, optionally filtered by state and point-in-time.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.asOf
 * @param data.state
 * @param data.includeAll
 * @returns SmartField_Api_Contracts_ExperimentalLocation_ExperimentalLocationDto OK
 * @throws ApiError
 */
export const experimentalLocationGetExperimentalLocations = (data: ExperimentalLocationGetExperimentalLocationsData): CancelablePromise<ExperimentalLocationGetExperimentalLocationsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/experimental-locations',
    path: {
        siteId: data.siteId
    },
    query: {
        asOf: data.asOf,
        state: data.state,
        includeAll: data.includeAll
    }
}); };

/**
 * Create a new experimental location (Plot or Field) for a site.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.requestBody
 * @returns SmartField_Api_Contracts_ExperimentalLocation_ExperimentalLocationDto Created
 * @throws ApiError
 */
export const experimentalLocationCreateExperimentalLocation = (data: ExperimentalLocationCreateExperimentalLocationData): CancelablePromise<ExperimentalLocationCreateExperimentalLocationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sites/{siteId}/experimental-locations',
    path: {
        siteId: data.siteId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Get a single experimental location by id.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @returns SmartField_Api_Contracts_ExperimentalLocation_ExperimentalLocationDto OK
 * @throws ApiError
 */
export const experimentalLocationGetExperimentalLocation = (data: ExperimentalLocationGetExperimentalLocationData): CancelablePromise<ExperimentalLocationGetExperimentalLocationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/experimental-locations/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Update an experimental location's name, number, polygon, or validity window.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const experimentalLocationUpdateExperimentalLocation = (data: ExperimentalLocationUpdateExperimentalLocationData): CancelablePromise<ExperimentalLocationUpdateExperimentalLocationResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/v1/sites/{siteId}/experimental-locations/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Soft-delete an experimental location.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @returns void No Content
 * @throws ApiError
 */
export const experimentalLocationDeleteExperimentalLocation = (data: ExperimentalLocationDeleteExperimentalLocationData): CancelablePromise<ExperimentalLocationDeleteExperimentalLocationResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v1/sites/{siteId}/experimental-locations/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Get treatments for a specific experimental location (plot).
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @returns SmartField_Api_Contracts_ExperimentalLocation_ExperimentalLocationTreatmentDto OK
 * @throws ApiError
 */
export const experimentalLocationGetTreatments = (data: ExperimentalLocationGetTreatmentsData): CancelablePromise<ExperimentalLocationGetTreatmentsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/experimental-locations/{id}/treatments',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Update the friendly name of a treatment.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @param data.treatmentId
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const experimentalLocationUpdateTreatment = (data: ExperimentalLocationUpdateTreatmentData): CancelablePromise<ExperimentalLocationUpdateTreatmentResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v1/sites/{siteId}/experimental-locations/{id}/treatments/{treatmentId}',
    path: {
        siteId: data.siteId,
        id: data.id,
        treatmentId: data.treatmentId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * List field notes for a site, newest first. Pass experimentalLocationId to only list notes on that location.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.experimentalLocationId
 * @returns SmartField_Api_Contracts_FieldNotes_FieldNoteDto OK
 * @throws ApiError
 */
export const fieldNotesGetFieldNotes = (data: FieldNotesGetFieldNotesData): CancelablePromise<FieldNotesGetFieldNotesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/field-notes',
    path: {
        siteId: data.siteId
    },
    query: {
        experimentalLocationId: data.experimentalLocationId
    },
    errors: {
        403: 'Forbidden'
    }
}); };

/**
 * Create a field note on one or more experimental locations of the site, or on the whole site when
 * `experimentalLocationIds` is empty or omitted.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.requestBody
 * @returns SmartField_Api_Contracts_FieldNotes_FieldNoteDto Created
 * @throws ApiError
 */
export const fieldNotesCreateFieldNote = (data: FieldNotesCreateFieldNoteData): CancelablePromise<FieldNotesCreateFieldNoteResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sites/{siteId}/field-notes',
    path: {
        siteId: data.siteId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Soft-delete a field note. Only the author or a site manager may delete.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @returns void No Content
 * @throws ApiError
 */
export const fieldNotesDeleteFieldNote = (data: FieldNotesDeleteFieldNoteData): CancelablePromise<FieldNotesDeleteFieldNoteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v1/sites/{siteId}/field-notes/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Lists files and directories within a blob container at the specified path
 * @param data The data for the request.
 * @param data.containerName The name of the blob container to browse
 * @param data.path The directory path to list (empty for root)
 * @param data.includeMetadata
 * @param data.includeTags
 * @returns SmartField_Api_Contracts_Files_BlobHierarchyItemDto Returns the files and directories in the given path
 * @throws ApiError
 */
export const filesListFiles = (data: FilesListFilesData): CancelablePromise<FilesListFilesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/files/container/{containerName}/browse',
    path: {
        containerName: data.containerName
    },
    query: {
        path: data.path,
        includeMetadata: data.includeMetadata,
        includeTags: data.includeTags
    },
    errors: {
        404: "If the container doesn't exist or the path is invalid"
    }
}); };

/**
 * @param data The data for the request.
 * @param data.containerName
 * @param data.blobName The entire path to the blob.
 * @returns binary OK
 * @throws ApiError
 */
export const filesDownloadFile = (data: FilesDownloadFileData): CancelablePromise<FilesDownloadFileResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/files/container/{containerName}/download',
    path: {
        containerName: data.containerName
    },
    query: {
        blobName: data.blobName
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const fluxGradientCalculateFluxGradient = (data: FluxGradientCalculateFluxGradientData = {}): CancelablePromise<FluxGradientCalculateFluxGradientResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/flux-gradient/schedule-flux-gradient-calculation',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns unknown OK
 * @throws ApiError
 */
export const geographyUpdateExperimentalLocationPolygons = (): CancelablePromise<GeographyUpdateExperimentalLocationPolygonsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/geography/experimental-locations/update-polygons',
    errors: {
        500: 'Internal Server Error'
    }
}); };

/**
 * Checks all healthchecks and returns a 200 OK if all are healthy, otherwise returns a 503 Service Unavailable.
 * @returns unknown The application is healthy
 * @throws ApiError
 */
export const healthCheckIsHealthy = (): CancelablePromise<HealthCheckIsHealthyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/healthchecks/healthy',
    errors: {
        503: 'The application is unavailable'
    }
}); };

/**
 * Checks all healthchecks that are deemed critical and returns a 200 OK if all are healthy, otherwise returns a 503 Service Unavailable.
 * @returns unknown The application is healthy
 * @throws ApiError
 */
export const healthCheckIsAlive = (): CancelablePromise<HealthCheckIsAliveResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/healthchecks/alive',
    errors: {
        503: 'The application is unavailable'
    }
}); };

/**
 * Get all active plots for a site.
 * @param data The data for the request.
 * @param data.siteId
 * @returns SmartField_Api_Contracts_Plot_PlotDto OK
 * @throws ApiError
 */
export const plotGetPlots = (data: PlotGetPlotsData): CancelablePromise<PlotGetPlotsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/plots',
    path: {
        siteId: data.siteId
    }
}); };

/**
 * Create a new plot polygon for a site.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.requestBody
 * @returns SmartField_Api_Contracts_Plot_PlotDto Created
 * @throws ApiError
 */
export const plotCreatePlot = (data: PlotCreatePlotData): CancelablePromise<PlotCreatePlotResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sites/{siteId}/plots',
    path: {
        siteId: data.siteId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Get a single plot by id.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @returns SmartField_Api_Contracts_Plot_PlotDto OK
 * @throws ApiError
 */
export const plotGetPlot = (data: PlotGetPlotData): CancelablePromise<PlotGetPlotResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/plots/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Update a plot's name, number, or polygon.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const plotUpdatePlot = (data: PlotUpdatePlotData): CancelablePromise<PlotUpdatePlotResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/v1/sites/{siteId}/plots/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Soft-delete a plot.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @returns void No Content
 * @throws ApiError
 */
export const plotDeletePlot = (data: PlotDeletePlotData): CancelablePromise<PlotDeletePlotResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v1/sites/{siteId}/plots/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * List sensors, optionally filtered by site or unplaced-only.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.unplacedOnly
 * @param data.asOf
 * @returns SmartField_Api_Contracts_Sensor_DimSensorDto OK
 * @throws ApiError
 */
export const sensorGetSensors = (data: SensorGetSensorsData = {}): CancelablePromise<SensorGetSensorsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sensors',
    query: {
        siteId: data.siteId,
        unplacedOnly: data.unplacedOnly,
        asOf: data.asOf
    }
}); };

/**
 * Get a single sensor by id.
 * @param data The data for the request.
 * @param data.id
 * @returns SmartField_Api_Contracts_Sensor_DimSensorDto OK
 * @throws ApiError
 */
export const sensorGetSensor = (data: SensorGetSensorData): CancelablePromise<SensorGetSensorResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sensors/{id}',
    path: {
        id: data.id
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Get placement history for a sensor (all timeline rows, newest first).
 * @param data The data for the request.
 * @param data.id
 * @returns SmartField_Api_Contracts_Sensor_DimSensorPlacementHistoryEntryDto OK
 * @throws ApiError
 */
export const sensorGetPlacementHistory = (data: SensorGetPlacementHistoryData): CancelablePromise<SensorGetPlacementHistoryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sensors/{id}/placement-history',
    path: {
        id: data.id
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Apply a placement to a sensor (splice or overwrite-forward).
 * @param data The data for the request.
 * @param data.id
 * @param data.siteId
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const sensorPostPlacement = (data: SensorPostPlacementData): CancelablePromise<SensorPostPlacementResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sensors/{id}/placement',
    path: {
        id: data.id
    },
    query: {
        siteId: data.siteId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Update measurement heights for a sensor.
 * @param data The data for the request.
 * @param data.id
 * @param data.siteId
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const sensorPatchProperties = (data: SensorPatchPropertiesData): CancelablePromise<SensorPatchPropertiesResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v1/sensors/{id}/properties',
    path: {
        id: data.id
    },
    query: {
        siteId: data.siteId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Bulk-apply chamber/tower properties to all sensors matching a device-type filter (or an explicit sensor id list)
 * on an experimental location, creating a new timeline row per sensor for the given effective range.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const sensorBulkApplyProperties = (data: SensorBulkApplyPropertiesData): CancelablePromise<SensorBulkApplyPropertiesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sites/{siteId}/sensors/bulk-apply-properties',
    path: {
        siteId: data.siteId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Schedules sensor aggregation for the given time range.
 * Publishes one message per day to the message bus for reliable distributed processing.
 * @param data The data for the request.
 * @param data.startTime
 * @param data.stopTime
 * @returns unknown OK
 * @throws ApiError
 */
export const sensorAggregationScheduleAggregation = (data: SensorAggregationScheduleAggregationData = {}): CancelablePromise<SensorAggregationScheduleAggregationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sensor-aggregation/aggregate',
    query: {
        startTime: data.startTime,
        stopTime: data.stopTime
    }
}); };

/**
 * Get all Sites
 * This endpoint is used on the dashboard thus <b>accessible anonymously</b>
 * @returns SmartField_Api_Contracts_Site_SiteDto OK
 * @throws ApiError
 */
export const siteGetSites = (): CancelablePromise<SiteGetSitesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites'
}); };

/**
 * Creates a Site from the values of the body.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SmartField_Api_Contracts_Site_SiteDto Created
 * @throws ApiError
 */
export const siteCreateSite = (data: SiteCreateSiteData = {}): CancelablePromise<SiteCreateSiteResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sites',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden'
    }
}); };

/**
 * Get the Site matching id.
 * @param data The data for the request.
 * @param data.id <example>Example: `1`</example>
 * @returns SmartField_Api_Contracts_Site_SiteDto OK
 * @throws ApiError
 */
export const siteGetSite = (data: SiteGetSiteData): CancelablePromise<SiteGetSiteResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{id}',
    path: {
        id: data.id
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Updates the Site matching id, with values from the body.
 *
 * Every updated field creates a Site History Entry with the new value.
 * @param data The data for the request.
 * @param data.id <example>Example: `1`</example>
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const siteUpdateSite = (data: SiteUpdateSiteData): CancelablePromise<SiteUpdateSiteResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/v1/sites/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Get all Site History Entries for the Site with id matching id.
 * @param data The data for the request.
 * @param data.id <example>Example: `1`</example>
 * @returns SmartField_Api_Contracts_SiteHistory_SiteHistoryEntryDto OK
 * @throws ApiError
 */
export const siteGetSiteHistory = (data: SiteGetSiteHistoryData): CancelablePromise<SiteGetSiteHistoryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{id}/history',
    path: {
        id: data.id
    }
}); };

/**
 * Set when the Site matching id started measuring.
 *
 * This creates a Site History Entry with the new value
 * @param data The data for the request.
 * @param data.id <example>Example: `1`</example>
 * @param data.startedAtUtc When the Site started measuring.
 *
 * <example>Example, 25th of January 2025 at noon: `2025-01-25 12:00`</example>
 * @returns void No Content
 * @throws ApiError
 */
export const siteSetStarted = (data: SiteSetStartedData): CancelablePromise<SiteSetStartedResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v1/sites/{id}/set-started',
    path: {
        id: data.id
    },
    query: {
        startedAtUtc: data.startedAtUtc
    },
    errors: {
        403: 'The user is not a site manager.',
        404: 'The site was not found.'
    }
}); };

/**
 * Set when the Site matching id stopped measuring.
 *
 * This creates a Site History Entry with the new value
 * @param data The data for the request.
 * @param data.id <example>Example: `1`</example>
 * @param data.stoppedAtUtc When the Site stopped measuring.
 *
 * <example>Example, 25th of February 2025 at noon: `2025-02-25 12:00`</example>
 * @returns void No Content
 * @throws ApiError
 */
export const siteSetStopped = (data: SiteSetStoppedData): CancelablePromise<SiteSetStoppedResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v1/sites/{id}/set-stopped',
    path: {
        id: data.id
    },
    query: {
        stoppedAtUtc: data.stoppedAtUtc
    },
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Set the location of the Site matching id.
 *
 * This creates a Site History Entry with the new value
 * @param data The data for the request.
 * @param data.id <example>Example: `1`</example>
 * @param data.requestBody The location of the Site in latitude/longitude (WGS84).
 *
 * <example>Example, Agro Food Park 15: ```
 * {
 * "x": 56.20025,
 * "y": 10.15842
 * }
 *
 * ```</example>
 * @returns void No Content
 * @throws ApiError
 */
export const siteSetLocation = (data: SiteSetLocationData): CancelablePromise<SiteSetLocationResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v1/sites/{id}/set-location',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Set the shape of the Site matching id.
 *
 * This creates a Site History Entry with the new value
 * @param data The data for the request.
 * @param data.id <example>Example: `1`</example>
 * @param data.requestBody A list of coordinates (WGS84) describing the shape of the Site. If the shape is not closed, the API will try to close it.
 *
 * <example>Example, a square in Agro Food Park:
 * ```
 * [
 * {
 * "x": 56.20025,
 * "y": 10.15842
 * },
 * {
 * "x": 56.20025,
 * "y": 10.15862
 * },
 * {
 * "x": 56.20055,
 * "y": 10.15842
 * },
 * {
 * "x": 56.20055,
 * "y": 10.15862
 * }
 * ]
 *
 * ```</example>
 * @returns void No Content
 * @throws ApiError
 */
export const siteSetShape = (data: SiteSetShapeData): CancelablePromise<SiteSetShapeResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v1/sites/{id}/set-shape',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Set the name of the Site matching id.
 *
 * This creates a Site History Entry with the new value
 * @param data The data for the request.
 * @param data.id <example>Example: `1`</example>
 * @param data.name <example>Example: `Supersite A`</example>
 * @returns void No Content
 * @throws ApiError
 */
export const siteSetName = (data: SiteSetNameData): CancelablePromise<SiteSetNameResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v1/sites/{id}/set-name',
    path: {
        id: data.id
    },
    query: {
        name: data.name
    },
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Export site geometry as GeoJSON. One feature per unique physical location (plot, field, block, miniblock, site boundary).
 * Coordinates are RFC 7946-compliant [longitude, latitude] order (WGS84 / EPSG:4326), produced by NTS GeoJsonConverterFactory.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.asOf
 * @returns unknown OK
 * @throws ApiError
 */
export const siteGeometryExportGeoJson = (data: SiteGeometryExportGeoJsonData): CancelablePromise<SiteGeometryExportGeoJsonResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/export/geojson',
    path: {
        siteId: data.siteId
    },
    query: {
        asOf: data.asOf
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Export site geometry as a zip bundle containing the GeoJSON plus a QGIS .qml style file
 * that categorizes colors by `type` and layers site→field→block→miniblock→plot bottom-to-top.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.asOf
 * @returns unknown OK
 * @throws ApiError
 */
export const siteGeometryExportGeoJsonBundle = (data: SiteGeometryExportGeoJsonBundleData): CancelablePromise<SiteGeometryExportGeoJsonBundleResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/export/geojson-bundle',
    path: {
        siteId: data.siteId
    },
    query: {
        asOf: data.asOf
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Import geometry from a GeoJSON file. Use ?dryRun=true to preview without persisting.
 * With ?createMissing=true, field/block/mini-block/plot features that don't match an existing location are created
 * (NFTS entity identifiers, so flux mappings resolve to them) valid from validFrom to validTo.
 * Plot features may carry `treatmentNumber`/`treatmentName` to link a treatment,
 * and `blockId`/`miniBlockId` to record which block and mini-block the plot belongs to.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.dryRun
 * @param data.createMissing
 * @param data.validFrom
 * @param data.validTo
 * @param data.formData
 * @returns SmartField_Api_Contracts_SiteGeometry_GeoJsonImportResultDto OK
 * @throws ApiError
 */
export const siteGeometryImportGeoJson = (data: SiteGeometryImportGeoJsonData): CancelablePromise<SiteGeometryImportGeoJsonResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sites/{siteId}/import/geojson',
    path: {
        siteId: data.siteId
    },
    query: {
        dryRun: data.dryRun,
        createMissing: data.createMissing,
        validFrom: data.validFrom,
        validTo: data.validTo
    },
    formData: data.formData,
    mediaType: 'multipart/form-data',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Get all Site History Entries for all Sites.
 * @returns SmartField_Api_Contracts_SiteHistory_SiteHistoryEntryDto OK
 * @throws ApiError
 */
export const siteHistoryGetSiteHistoryEntries = (): CancelablePromise<SiteHistoryGetSiteHistoryEntriesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sitehistory'
}); };

/**
 * Get the Site History Entry matching id.
 * @param data The data for the request.
 * @param data.id
 * @returns SmartField_Api_Contracts_SiteHistory_SiteHistoryEntryDto OK
 * @throws ApiError
 */
export const siteHistoryGetSiteHistoryEntry = (data: SiteHistoryGetSiteHistoryEntryData): CancelablePromise<SiteHistoryGetSiteHistoryEntryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sitehistory/{id}',
    path: {
        id: data.id
    },
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Get all Site Operation Log Entries for the site matching siteId.
 * @param data The data for the request.
 * @param data.siteId ID of the site
 * @returns SmartField_Api_Contracts_SiteOperationLog_SiteOperationLogEntryDto OK
 * @throws ApiError
 */
export const siteOperationLogGetSiteOperationLogEntriesForSite = (data: SiteOperationLogGetSiteOperationLogEntriesForSiteData): CancelablePromise<SiteOperationLogGetSiteOperationLogEntriesForSiteResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/siteoperationlogs/site/{siteId}',
    path: {
        siteId: data.siteId
    }
}); };

/**
 * Get the Site Operation Log Entry matching id.
 * @param data The data for the request.
 * @param data.id
 * @returns SmartField_Api_Contracts_SiteOperationLog_SiteOperationLogEntryDto OK
 * @throws ApiError
 */
export const siteOperationLogGetSiteOperationLogEntry = (data: SiteOperationLogGetSiteOperationLogEntryData): CancelablePromise<SiteOperationLogGetSiteOperationLogEntryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/siteoperationlogs/{id}',
    path: {
        id: data.id
    },
    errors: {
        404: 'Not Found'
    }
}); };

/**
 * Creates a Site Operation Log Entry from the values of the body.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SmartField_Api_Contracts_SiteOperationLog_SiteOperationLogEntryDto Created
 * @throws ApiError
 */
export const siteOperationLogCreateSiteOperationLogEntry = (data: SiteOperationLogCreateSiteOperationLogEntryData = {}): CancelablePromise<SiteOperationLogCreateSiteOperationLogEntryResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/siteoperationlogs',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.siteId
 * @param data.year
 * @returns SmartField_Api_Contracts_Mapping_TowerMappingDto OK
 * @throws ApiError
 */
export const towerMappingGetTowerMappings = (data: TowerMappingGetTowerMappingsData): CancelablePromise<TowerMappingGetTowerMappingsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/tower-mappings',
    path: {
        siteId: data.siteId
    },
    query: {
        year: data.year
    }
}); };

/**
 * @param data The data for the request.
 * @param data.siteId
 * @param data.requestBody
 * @returns SmartField_Api_Contracts_Mapping_TowerMappingDto Created
 * @throws ApiError
 */
export const towerMappingCreateTowerMapping = (data: TowerMappingCreateTowerMappingData): CancelablePromise<TowerMappingCreateTowerMappingResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/sites/{siteId}/tower-mappings',
    path: {
        siteId: data.siteId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const towerMappingUpdateTowerMapping = (data: TowerMappingUpdateTowerMappingData): CancelablePromise<TowerMappingUpdateTowerMappingResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/v1/sites/{siteId}/tower-mappings/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.siteId
 * @param data.id
 * @returns void No Content
 * @throws ApiError
 */
export const towerMappingDeleteTowerMapping = (data: TowerMappingDeleteTowerMappingData): CancelablePromise<TowerMappingDeleteTowerMappingResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/v1/sites/{siteId}/tower-mappings/{id}',
    path: {
        siteId: data.siteId,
        id: data.id
    },
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * Get all treatments for a site, with the IDs of the plot experimental locations they are linked to.
 * @param data The data for the request.
 * @param data.siteId
 * @returns SmartField_Api_Contracts_ExperimentalLocation_SiteTreatmentDto OK
 * @throws ApiError
 */
export const treatmentsGetSiteTreatments = (data: TreatmentsGetSiteTreatmentsData): CancelablePromise<TreatmentsGetSiteTreatmentsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/v1/sites/{siteId}/treatments',
    path: {
        siteId: data.siteId
    }
}); };

/**
 * Update the friendly name of a treatment belonging to this site.
 * @param data The data for the request.
 * @param data.siteId
 * @param data.treatmentId
 * @param data.requestBody
 * @returns void No Content
 * @throws ApiError
 */
export const treatmentsUpdateTreatment = (data: TreatmentsUpdateTreatmentData): CancelablePromise<TreatmentsUpdateTreatmentResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/v1/sites/{siteId}/treatments/{treatmentId}',
    path: {
        siteId: data.siteId,
        treatmentId: data.treatmentId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        403: 'Forbidden',
        404: 'Not Found'
    }
}); };

/**
 * @param data The data for the request.
 * @param data.formData
 * @returns unknown OK
 * @throws ApiError
 */
export const webhookMeterGroupWebhookEndpoint = (data: WebhookMeterGroupWebhookEndpointData = {}): CancelablePromise<WebhookMeterGroupWebhookEndpointResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/v1/webhooks',
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };